import { create } from 'zustand';
import { PageData } from '../dto/EntityRepository';
import { PerPage } from '../enum/EnumRepository';

interface PageState {
  page: PageData;
  setPage: (value: PageData) => void;
  resetPage: () => void;
}

export interface ModalPageState {
  modalPage: PageData;
  setModalPage: (value: PageData) => void;
  resetModalPage: () => void;
}

const initialPageData: PageData = {
  page: 1,
  size: PerPage.PAGE_10,
  totalElements: 0,
  totalPages: 0,
};

export const usePageStore = create<PageState>((set) => ({
  page: initialPageData,
  setPage: (value) => set({ page: value }),
  resetPage: () => set({ page: initialPageData }),
}));

export const useModalPageStore = create<ModalPageState>((set) => ({
  modalPage: initialPageData,
  setModalPage: (value) => set({ modalPage: value }),
  resetModalPage: () => set({ modalPage: initialPageData }),
}));
